import { Avatar as MuiAvatar, Box as MuiBox } from "@mui/material";
import { alpha, styled } from "@mui/material/styles";

const OVERLAP_RATIO = 0.5;
const MARK_RADIUS_RATIO = 0.28;

export const PlatformIconsWrapper = styled(MuiBox)({
  display: "flex",
  alignItems: "center",
  width: "fit-content",
});

export const PlatformIcon = styled(MuiAvatar, {
  shouldForwardProp: (prop) => prop !== "size" && prop !== "isFirst",
})<{ size: number; isFirst: boolean }>(({ size, isFirst }) => ({
  width: size,
  height: size,
  flexShrink: 0,
  border: "1px solid #fff",
  boxSizing: "border-box",
  marginLeft: isFirst ? 0 : `-${size * OVERLAP_RATIO}px`,

  "& img": {
    objectFit: "cover",
  },
}));

export const MarksWrapper = styled("span")({
  display: "flex",
  alignItems: "center",
  gap: 4,
});

export const LogoMark = styled("img", {
  shouldForwardProp: (prop) => prop !== "size",
})<{ size: number }>(({ size }) => ({
  display: "block",
  flex: "none",
  width: size,
  height: size,
  borderRadius: size * MARK_RADIUS_RATIO,
  objectFit: "cover",
}));

export const MarksOverflow = styled("span")(({ theme }) => ({
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  flex: "none",
  minWidth: 18,
  height: 18,
  padding: "0 4px",
  boxSizing: "border-box",
  borderRadius: 5,
  fontSize: 10,
  fontWeight: 700,
  lineHeight: "normal",
  letterSpacing: "normal",
  cursor: "default",
  backgroundColor:
    theme.palette.mode === "dark"
      ? alpha(theme.palette.common.white, 0.12)
      : "#F4F4F5",
  color: theme.palette.mode === "dark" ? theme.palette.grey[400] : "#52525B",
}));
